import { RootState } from "../../../../models";

export const getVouchers = (state: RootState) => state.voucher;
export const getValidatedVouchers = (state: RootState) => getVouchers(state).validatedVouchers;
export const getVoucherCode = (state: RootState) => getVouchers(state).code;
export const getVoucherValidationMessage = (state: RootState) => getVouchers(state).validationMessage;
export const getTotalVoucherDiscount = (state: RootState) =>
    getValidatedVouchers(state).reduce((acc, voucher) => acc + voucher.usedBalance, 0);
